/**
 * Confirmation modal shown when a user selects "Cancel" from the Expense
 * Inventory detail Actions dropdown. Unlike the Inventory Request cancel
 * flow, this does not require an existing comment from the current user
 * before cancelling.
 * @module src/components/Inventory/expense/detail/ExpenseInventoryCancelModal
 */
import React, { FC } from 'react';
import Modal from '@salesforce/design-system-react/components/modal';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Spinner from '@salesforce/design-system-react/components/spinner';
import Button from '@salesforce/design-system-react/components/button';

interface Props {
  isOpen: boolean;
  caseNumber?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ExpenseInventoryCancelModal: FC<Props> = ({
  isOpen,
  caseNumber,
  loading = false,
  onClose,
  onConfirm,
}) => {
  return (
    <IconSettings iconPath="/icons">
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        dismissOnClickOutside={false}
        ariaHideApp={false}
        heading={
          <div className="slds-float_left slds-text-title_bold slds-text-heading_medium">
            {`Expense Inventory ${caseNumber || ''}`}
          </div>
        }
        footer={[
          <div className="slds-align_absolute-center" key="cancel_expense_inventory">
            {loading && (
              <Spinner size="small" variant="base" assistiveText={{ label: 'Cancelling...' }} />
            )}
            <Button label="No" onClick={onClose} />
            <Button style={{ backgroundColor: '#ffb501' }} label="Yes" onClick={onConfirm} />
          </div>,
        ]}
      >
        <section>
          <div style={{ position: 'relative', padding: '1rem' }}>
            {`Are you sure you want to cancel this Expense Inventory case?`}
          </div>
        </section>
      </Modal>
    </IconSettings>
  );
};

/** Cancel Expense Inventory confirmation modal **/
export default ExpenseInventoryCancelModal;
